module.exports = __webpack_public_path__ + "static/media/video.7aa85a17.mp4";